var map = {
	"./acn-logo-colour.png": 39863,
	"./championnat-africain-logo-colour.png": 56715,
	"./chlg-logo-colour.png": 5329,
	"./epl-logo-colour.png": 61064,
	"./euro-logo-colour.png": 7432,
	"./european-championship-2024-logo-colour.png": 9903,
	"./fifa-world-cup-logo-colour.png": 53331,
	"./fran-logo-colour.png": 71082,
	"./french-ligue-1-logo-colour.png": 64004,
	"./la-liga-logo-colour.png": 94918,
	"./liga-logo-colour.png": 69926,
	"./natl-logo-colour.png": 21236,
	"./psl-logo-colour.png": 56088,
	"./safr-logo-colour.png": 76627,
	"./serie-a-logo-colour.png": 28487,
	"./seriea-logo-colour.png": 12842,
	"./uefa-champions-league-logo-colour.png": 55509,
	"./women's-world-cup-logo-colour.png": 89297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66266;